export default {
  search: {
    title: 'Choose your destination',
    departureDate: 'Departure',
    returnDate: 'Return',
    continue: 'Continue',
  },
  travelPlanner: {
    search: {
      origin: 'From',
      destination: 'To',
      switchDirection: 'Switch direction',
    },
    passenger: {
      addPassenger: 'Add',
      removePassenger: 'Remove',
      travelCard: {
        placeholder: 'Select travel card',
        addTravelCard: 'Add travel card',
        reminder: 'Please note that you must show a valid season ticket when boarding.',
      },
    },
  },
  common: {
    actions: {
      clear: 'Clear field',
      save: 'Save',
    },
    passenger: {
      title: 'Passengers',
      passengers: 'passengers',
    },
  },
  components: {
    button: {
      cancel: 'Cancel',
    },
    dropdown: {
      select: 'Select',
      noResults: 'No results found',
    },
  },
  descriptions: {
    passengerNames: {
      ADT: 'Adult',
      CHD: 'Child 0 - 5',
      YOU: 'Child 6 - 17',
      STU: 'Student',
      SEN: 'Senior',
      COM: 'Companion',
      CON: 'Conscript',
    },
  },
}
